import Gap from 'src/components/atoms/Gap';
import { Icon } from 'src/components/atoms/Icon';
import Text, { TextVariant } from 'src/components/atoms/Text';
import { StyledInstructionCard } from './styles';
import PropTypes from 'prop-types';

interface Props {
  hasClearProvider?: boolean;
  hasIncodeProvider?: boolean;
}

const IDVLinkInstruction: React.FC<Props> = ({ hasClearProvider, hasIncodeProvider }) => {
  return (
    <StyledInstructionCard border alignContent="center">
      <Icon color="primary" icon="warning" />
      <Gap height={1.1875} />

      {hasIncodeProvider && (
        <>
          <Text color="gray700" variant={TextVariant.small}>
            Select the ‘Applicants Link’ button to copy the IDV link to your clipboard. From here,
            you can paste into an email or text to send to your applicant.
          </Text>
          <Gap height={2} />
          <Text color="gray700" variant={TextVariant.small}>
            Please note, each link is unique and a new one should be generated for each applicant.
            Only the individual whose ID is being verified should proceed through the verification
            workflow.
          </Text>
          <Gap height={2} />
        </>
      )}

      {hasClearProvider && (
        <>
          <Text color="gray700" variant={TextVariant.small}>
            Identity verification is powered by CLEAR, the secure identity network. Choose between
            two verification flows based on your needs:
          </Text>
          <Gap height={2} />
          <Text color="gray700" variant={TextVariant.small}>
            ◦ Enhanced ID Verification Link Use for: Online applications or high-assurance scenarios
            Includes: ID document check, facial biometrics, and device validation
          </Text>
          <Gap height={2} />
          <Text color="gray700" variant={TextVariant.small}>
            ◦ Basic ID Verification Link Use for: Low-friction scenarios like property tours or
            initial lead capture Includes: Name, DOB, and device ownership—no selfie or ID scan
            required.
          </Text>
          <Gap height={2} />
          <Text color="gray700" variant={TextVariant.small}>
            Each property has a single set of reusable links. Copy the relevant link below and send
            it via email or text to your applicant or convert the link to a QR code and post it at
            your property.
          </Text>
        </>
      )}
    </StyledInstructionCard>
  );
};

IDVLinkInstruction.propTypes = {
  hasClearProvider: PropTypes.bool,
  hasIncodeProvider: PropTypes.bool
};

export default IDVLinkInstruction;
